import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createContext } from 'react';
export const configurationProviderContext = createContext({});
/**
 * Provides configuration, our emotion theme and current breakpoint to other packages utilizing the ConfigurationProvider.
 */
export const ConfigurationProvider = ({
  value,
  children
}) => {
  return _jsx(configurationProviderContext.Provider, {
    value: value,
    children: children
  });
};